/*
 * @providesModule SKZStyleSheet
 * 
 */

import _ from 'lodash';

import {
  StyleSheet
}  from 'react-native';

export default class SKZStyleSheet {
  constructor(props: Object) {
    this.originalStyles = props;

    this.register(props);
  }

  register(styles: Object): SKZStyleSheet {
    //console.debug('register styles:' + JSON.stringify(styles) + ' for this: ' + JSON.stringify(this));
    const registeredStyles = StyleSheet.create(styles);
    Object.assign(this, registeredStyles);
    //console.debug('post register:' + JSON.stringify(this));
    return this;
  }

  scaleProps(props: Object, scale: number): Object {
    this.scaleValue = scale;
    const scaledStyles = {};
    _.keys(this.originalStyles).forEach((key: StyleObj) => {
      const style = this.originalStyles[key];
      if (style) {
        const scaledStyle = Object.assign({}, style);
        props.forEach((propKey: string) => {
          if (scaledStyle[propKey]) {
            //console.debug('update prop for key:' + propKey);
            scaledStyle[propKey] = scaledStyle[propKey] * scale;
            //console.debug(key + '.' + propKey + ' updated: ' + scaledStyle[propKey] + ' original: '+ style[propKey]);
          }
        });
        scaledStyles[key] = scaledStyle;
      }
    });

    this.register(scaledStyles);

    return scaledStyles;
  }

  scaleSizes(scale: number): Object {
    const scaledStyles = this.scaleProps(['height', 'width'], scale);
    return scaledStyles;
  }

  scaleMargins(scale: number): Object {
    const scaledStyles = this.scaleProps(
      [
        'margin',
        'marginHorizontal',
        'marginVertical',
        'marginLeft',
        'marginRight',
        'marginTop',
        'marginBottom'
      ],
      scale);
    return scaledStyles;
  }

  scalePadding(scale: number): Object { // this method has no side effects
    const scaledStyles = this.scaleProps(
      [
        'padding',
        'paddingHorizontal',
        'paddingVertical',
        'paddingLeft',
        'paddingRight',
        'paddingTop',
        'paddingBottom'
      ],
      scale);

    return scaledStyles;
  }

  static filterFromStyle(inStyle: StyleObj): Object {
    let incomingStyle = inStyle;
    if (!Array.isArray(incomingStyle)) {
      incomingStyle = [incomingStyle];
    }

    const styleArray = incomingStyle.map((item: StyleObj): Object => {
      return StyleSheet.flatten(item);
    });

    const styleProps = {};
    _.assign(styleProps, ...styleArray);

    return styleProps;
  }

  scaleFonts(scale: number): Object {
    const scaledStyles = this.scaleProps(['fontSize'], scale);
    return scaledStyles;
  }
}
